import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AnexoService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  //listar por id
  show(id: string): Observable<any> {
    return this.apiService.get(
      `/api/Anexos/${id}`,
    ).pipe(
      map(response => response)
    );
  }


  delete(id: string): Observable<any> {
    return this.apiService.delete(`/api/Anexos/${id}`);
  }
}